



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { recordList } from '../api/index';
import { List } from 'vant';

Vue.use(List);
@Component
export default class RecordList extends Vue {
  @Prop() api!: string;
  @Prop() conf!: {};
  loading = false;
  finished = false;
  page = 1;
  listData: any = [];

  onLoad() {
    recordList(this.api, this.page).then((res: any) => {
      this.handleData(res);
    });
  }
  handleData(res: any) {
    if (res.msg === '暂无数据' || res.code === 500) {
      this.finished = true;
    } else {
      this.listData = [...this.listData, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
  }
  getLocalTime(nS: number | string): string {
    const date = new Date(parseInt(nS.toString(), 10) * 1000);
    const year = date.getFullYear();
    const month =
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    const m =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    const s =
      date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

    return `${year}/${month}/${day} ${h}:${m}:${s}`;
  }
}
